<template>
    <v-select
            :items="status"
            :label="label"
            v-model="value"
            :rules="rules"
            outlined
    ></v-select>
</template>

<script>
    import utils from '../utils';

    export default {
        name: "PersonStatus",
        props: {
            label: {
                type: String,
                default: 'Status'
            },
            value: {
                type: String
            },
            rules: {
                default: []
            }
        },
        watch: {
            value() {
                this.$emit('input', this.value);
            }
        },
        data: vm => ({
            status: utils.personStatus
        })
    }
</script>

<style scoped>

</style>
